import { render, staticRenderFns } from "./NoResult.vue?vue&type=template&id=1047e398"
var script = {}
import style0 from "./NoResult.vue?vue&type=style&index=0&id=1047e398&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports